import { Controller } from 'stimulus'

// Hubspot controller
export default class HS extends Controller {
  static WINDOW_PROPERTY = '_hsp'

  connect() {
    // If no HS script is found we may as well remove the "Cookie Preferences" as no cookies will
    // be set due to those preferences anyway.
    if (!this.isHsPresent()) this.element.remove()
  }

  showBanner(event) {
    window[HS.WINDOW_PROPERTY].push(['showBanner'])
    event.preventDefault()
  }

  isHsPresent() {
    // Privacy preferences can prevent the Hubspot script from being loaded altogether.
    return !!window[HS.WINDOW_PROPERTY]
  }
}
